module.exports = __webpack_public_path__ + "static/media/ectpl_logo_login.d9eef622.png";